import { render } from "./footerCom2.vue?vue&type=template&id=9f48b052&scoped=true"
const script = {}

import "./footerCom2.vue?vue&type=style&index=0&id=9f48b052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f48b052"]])

export default __exports__